/**
 * API Utilities — Wrapper sobre lib/api.js para backward compatibility
 * 
 * Todos os requests passam pelo apiFetch centralizado (tratamento de erros,
 * 401/402 redirect, network errors). Se o endpoint for relativo (/api/...),
 * adiciona API_URL para chamadas que precisam de URL absoluta.
 * 
 * Para novos componentes, prefira importar diretamente de '@/lib/api'.
 */

import { apiFetch } from '@/lib/api';

export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';

/**
 * Fetch with authentication via HttpOnly cookies
 * Delegates to apiFetch with centralized error handling
 */
export async function authFetch(endpoint, options = {}) {
    // apiFetch already handles credentials, Content-Type, FormData, errors
    return apiFetch(endpoint, options);
}

/**
 * GET request with authentication
 */
export async function authGet(endpoint) {
    return authFetch(endpoint, { method: 'GET' });
}

/**
 * POST request with authentication
 */
export async function authPost(endpoint, body) {
    return authFetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(body),
    });
}

/**
 * PUT request with authentication
 */
export async function authPut(endpoint, body) {
    return authFetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(body),
    });
}

/**
 * PATCH request with authentication
 */
export async function authPatch(endpoint, body) {
    return authFetch(endpoint, {
        method: 'PATCH',
        body: JSON.stringify(body),
    });
}

/**
 * DELETE request with authentication
 */
export async function authDelete(endpoint) {
    return authFetch(endpoint, { method: 'DELETE' });
}
